export interface ISessionEvent {
  id: string;
  userId: string;
  sessionId: string;
  recordedAt: number;
  type: string;
  metadata: Record<string, any>;
}

export abstract class SessionEvent implements ISessionEvent {
  id: string;
  userId: string;
  sessionId: string;
  recordedAt: number;
  type: string;
  metadata: Record<string, any>;
  deliveryAttempts?: number;

  protected constructor(type: string, metadata: Record<string, any>) {
    this.type = type;
    this.metadata = metadata;
  }
}

export abstract class SessionArticleEvent extends SessionEvent {
  articleId: string;

  protected constructor(
    type: string,
    articleId: string,
    metadata: Record<string, any>,
  ) {
    super(type, {
      articleId,
      ...(metadata || {}),
    });
    this.articleId = articleId;
  }
}
